import { ValidatorFn, AbstractControl } from "@angular/forms";

export const ValidatorPhone = (): ValidatorFn => {
  return (currentControl: AbstractControl): { [key: string]: any } => {
    let a = String(currentControl.value);
    if (a == null || a == "") {
      return null;
    }
    if (a.indexOf("_") > 0) {
      return {
        invalidPhone: true,
      };
    }
    return undefined;
  };
};
